/**
 * Analytics · Executive Dashboard
 * Demo content - see src/demo/analytics.ts.
 */

import React from 'react';
import { AppShell } from '../../components/shell/AppShell';
import { Card, Kpi, PageHead, Table, Tag, DemoBadge } from '../../components/ui';
import { ChartFrame, AreaTrend, Bars } from '../../components/charts';
import { EXEC } from '../../demo/analytics';

export const ExecutiveDashboardPage: React.FC = () => (
  <AppShell
    title="Executive Dashboard"
    sub="Analytics"
    actions={
      <>
        <DemoBadge />
        <button className="btn btn-g">This quarter</button>
        <button className="btn btn-p">Export</button>
      </>
    }
  >
    <PageHead
      eyebrow="Analytics"
      title="Executive dashboard"
      lede="The numbers the board asks about, resolved through certified definitions so revenue means the same thing on every screen."
    />

    <div className="g g4" style={{ marginBottom: 12 }}>
      {EXEC.kpis.map((k) => (
        <Kpi
          key={k.label}
          label={k.label}
          value={k.value}
          unit={'unit' in k ? (k as any).unit : undefined}
          color={k.color}
          icon={k.icon as any}
          pip={'pip' in k ? (k as any).pip : undefined}
          dir={('dir' in k ? (k as any).dir : '') as any}
          valueColor={k.color === 'var(--red)' ? 'var(--red)' : undefined}
        />
      ))}
    </div>

    <div className="g g2" style={{ marginBottom: 12 }}>
      <ChartFrame title="Revenue and cost of sales" sub="monthly, $M — REV-01">
        <AreaTrend
          data={EXEC.revenueByMonth}
          x="month"
          series={[
            { key: 'revenue', label: 'Revenue' },
            { key: 'cogs', label: 'Cost of sales' },
          ]}
        />
      </ChartFrame>

      <ChartFrame title="Open pipeline by region" sub="$M — PIPE-01">
        <Bars
          data={EXEC.pipelineByRegion}
          x="region"
          horizontal
          series={[{ key: 'value', label: 'Pipeline' }]}
        />
      </ChartFrame>
    </div>

    <div className="g g3">
      <ChartFrame title="Gross margin by product line" sub="%, current quarter">
        <Bars data={EXEC.marginByLine} x="line" series={[{ key: 'margin', label: 'Gross margin' }]} unit="%" />
      </ChartFrame>

      <div className="s2">
        <Card title="Largest accounts" sub="by revenue, trailing twelve months" flush>
          <Table
            cols={[
              { t: 'Account' },
              { t: 'Revenue', num: true },
              { t: 'Gross margin', num: true },
              { t: 'Change' },
            ]}
            rows={EXEC.topAccounts.map((a) => [
              <b>{a.account}</b>,
              a.revenue,
              a.margin,
              <Tag tone={a.tone as any}>{a.change}</Tag>,
            ])}
          />
        </Card>
      </div>
    </div>
  </AppShell>
);
